<template>
  <div id="root">
    <div id="signup" v-if="isShow">
      <div class="backdrop">
        <div class="img-container">
          <img src="../../assets/bg-intro.png" :style="setPos" alt="" />
        </div>
      </div>
      <comp-header
        :headerPosition="headerPos"
        :leftIcon="headerLeftIcon"
        :pageTitle="headerPageTitle"
        :leftClick="goAccLogin"
      ></comp-header>
      <div class="signup-wrapper">
        <div class="signup-container">
          <div class="form-area">
            <table class="form-table">
              <tr>
                <td class="icon-cell"><i class="fas fa-envelope"></i></td>
                <td>
                  <form-input
                    id="id-email"
                    :inputType="typeEmail"
                    :placeholderText="emailHolder"
                    :inputStyle="styleInputEmail ? styleUnder : styleUnderAlert"
                    :inputValue="inputEmail"
                    @inputParent="
                      value => {
                        inputEmail = value;
                      }
                    "
                  ></form-input>
                </td>
              </tr>
            </table>

            <table class="form-table">
              <tr>
                <td class="icon-cell"><i class="fas fa-key"></i></td>
                <td>
                  <form-input
                    id="id-password"
                    :inputType="typePW"
                    :placeholderText="pwHolder"
                    :inputStyle="
                      styleInputPassword ? styleUnder : styleUnderAlert
                    "
                    :inputValue="inputPassword"
                    @inputParent="
                      value => {
                        inputPassword = value;
                      }
                    "
                  ></form-input>
                </td>
              </tr>
            </table>

            <table class="form-table">
              <tr>
                <td class="icon-cell"><i class="fas fa-user"></i></td>
                <td>
                  <form-input
                    id="id-name"
                    :inputType="typeText"
                    :placeholderText="nameHolder"
                    :inputStyle="styleInputName ? styleUnder : styleUnderAlert"
                    :inputValue="inputName"
                    @inputParent="
                      value => {
                        inputName = value;
                      }
                    "
                  ></form-input>
                </td>
              </tr>
            </table>

            <table class="form-table">
              <tr>
                <td class="icon-cell"><i class="fas fa-user-tag"></i></td>
                <td>
                  <form-input
                    id="id-nickname"
                    :inputType="typeText"
                    :placeholderText="nickHolder"
                    :inputStyle="
                      styleInputNickname ? styleUnder : styleUnderAlert
                    "
                    :inputValue="inputNickname"
                    @inputParent="
                      value => {
                        inputNickname = value;
                      }
                    "
                  ></form-input>
                </td>
              </tr>
            </table>

            <table class="form-table">
              <tr>
                <td class="icon-cell"><i class="fas fa-calendar-alt"></i></td>
                <td>
                  <form-select
                    :inputStyle="styleUnder"
                    :optionDatas="this.years()"
                    @selectParent="checkBirth"
                    :selected="yearSelected"
                    :placeholderText="$t('common.birthYear')"
                  />
                </td>
              </tr>
            </table>

            <table class="form-table">
              <tr>
                <td class="icon-cell"><i class="fas fa-transgender"></i></td>
                <td>
                  <form-select
                    :inputStyle="styleUnder"
                    :optionDatas="this.sexes()"
                    @selectParent="checkSex"
                    :selected="sexSelected"
                    :placeholderText="$t('common.sex')"
                  />
                </td>
              </tr>
            </table>

            <table class="form-table">
              <tr>
                <td class="icon-cell"><i class="fas fa-graduation-cap"></i></td>
                <td>
                  <form-select
                    :inputStyle="styleUnder"
                    :optionDatas="this.educations()"
                    @selectParent="checkEducation"
                    :selected="educationSelected"
                    :placeholderText="$t('common.edu')"
                  />
                </td>
              </tr>
            </table>

            <table class="form-table">
              <tr>
                <td class="icon-cell"><i class="fas fa-briefcase"></i></td>
                <td style="padding: 0 15px">
                  <a @click="goPage('/acc/job-group')" class="btn-like-select">
                    {{ occupation }}
                  </a>
                </td>
              </tr>
            </table>

            <p class="comment">{{ $t("acc.signUp.necessary") }}</p>

            <form-button
              :btnName="buttonName"
              @click.native="
                signUp(
                  inputEmail,
                  inputPassword,
                  inputNickname,
                  inputName,
                  yearSelected,
                  sexSelected,
                  educationSelected
                )
              "
            ></form-button>
          </div>
        </div>
      </div>
    </div>
    <comp-modal v-if="showModal" titleShow @confirm="showModal = false">
      <div slot="header">{{ titleModal }}</div>
      <div slot="body">{{ msgModal }}</div>
    </comp-modal>
  </div>
</template>

<script>
import common from '@/utils/common';
import CompModal from '@/components/CompModal';
import CompHeader from '@/components/CompHeader';
import FormInput from '@/components/FormInput';
import FormButton from '@/components/FormButton';
import FormSelect from '@/components/FormSelect';
import RESPONSE from '@/constants/response';
import LOGIN_TYPE from '@/constants/loginType';
import SEX_TYPE from '@/constants/sexType';
import _ from 'lodash';

export default {
  name: 'singup',
  mixins: [common],
  data() {
    return {
      headerPos: 'on-top',
      headerLeftIcon: 'fa-chevron-left',
      headerPageTitle: this.$i18n.t('common.signUp'),
      // 폼 타입
      typeText: 'text',
      typeEmail: 'email',
      typePW: 'password',
      typeTel: 'tel',

      styleUnder: 'underline',
      styleUnderAlert: 'underline-alert',
      styleUnderColor: 'underline-color',

      emailHolder: this.$i18n.t('common.email'),
      pwHolder: this.$i18n.t('acc.signUp.pwHolder'),
      nameHolder: this.$i18n.t('common.name'),
      nickHolder: this.$i18n.t('common.nickname'),
      buttonName: this.$i18n.t('common.signUp'),

      inputEmail: this.$store.getters.getTmpUserEmail,
      inputPassword: this.$store.getters.getTmpUserPassword,
      inputNickname: this.$store.getters.getTmpUserNickname,
      inputName: this.$store.getters.getTmpUserName,

      validEmailFlag: this.$store.getters.getTmpValidEmailFlag,
      validPasswordFlag: this.$store.getters.getTmpValidPasswordFlag,
      validNicknameFlag: this.$store.getters.getTmpValidNicknameFlag,
      validNameFlag: this.$store.getters.getTmpValidNameFlag,

      yearSelected: this.$store.getters.getTmpUserBirth || '0',
      sexSelected: this.$store.getters.getTmpUserSex || '0',
      educationSelected: this.$store.getters.getTmpUserEducation || '0',

      occupation: this.$i18n.t('acc.signUp.occupation'),

      showModal: false,
      titleModal: '',
      msgModal: '',
      isShow: false,

      docHeight: window.innerHeight,
      docWidth: window.innerWidth,
    };
  },
  components: {
    CompHeader,
    FormInput,
    FormButton,
    FormSelect,
    CompModal,
  },

  computed: {
    styleInputEmail() {
      return this.validEmailFlag;
    },
    styleInputPassword() {
      return this.validPasswordFlag;
    },
    styleInputNickname() {
      return this.validNicknameFlag;
    },
    styleInputName() {
      return this.validNameFlag;
    },
    setPos() {
      const docHeight = this.docHeight;
      const docWidth = this.docWidth;
      let marginValue = '';
      if (docHeight > docWidth) {
        const marginCal = (docHeight - docWidth) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-left': marginValue,
          width: 'auto',
          height: '100%',
        };
      }
      if (docHeight < docWidth) {
        const marginCal = (docWidth - docHeight) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-top': marginValue,
          width: '100%',
          height: 'auto',
        };
      }
      return {
        width: '100%',
        height: 'auto',
      };
    },
  },

  methods: {
    checkUserId: _.debounce(function checkUserId() {
      this.$store.dispatch('setTmpUserEmail', this.inputEmail).then(() => {
        if (this.validEmail(this.inputEmail)) {
          return this.$store
            .dispatch('checkUserId', { userId: this.inputEmail })
            .then((result) => {
              this.validEmailFlag = result.status !== RESPONSE.FAIL.CODE;
              this.$store
                .dispatch('setTmpValidEmailFlag', this.validEmailFlag)
                .then(() => this.validEmailFlag);
            });
        }
        this.validEmailFlag = false;
        return this.$store
          .dispatch('setTmpValidEmailFlag', this.validEmailFlag)
          .then(() => this.validEmailFlag);
      });
    }, 1000),

    checkPassword: _.debounce(function checkPassword() {
      this.$store
        .dispatch('setTmpUserPassword', this.inputPassword)
        .then(() => {
          this.validPasswordFlag = this.validPassword(this.inputPassword);
          return this.$store
            .dispatch('setTmpValidPasswordFlag', this.validPasswordFlag)
            .then(() => this.validPasswordFlag);
        });
    }, 1000),

    checkNickname: _.debounce(function checkNickname() {
      this.$store
        .dispatch('setTmpUserNickname', this.inputNickname)
        .then(() => {
          if (this.validNickname(this.inputNickname)) {
            return this.$store
              .dispatch('checkNickname', { nickname: this.inputNickname })
              .then((result) => {
                this.validNicknameFlag = result.data.usable;
                this.$store
                  .dispatch('setTmpValidNicknameFlag', this.validNicknameFlag)
                  .then(() => this.validNicknameFlag);
              });
          }
          this.validNicknameFlag = false;
          return this.$store
            .dispatch('setTmpValidNicknameFlag', this.validNicknameFlag)
            .then(() => this.validNicknameFlag);
        });
    }, 1000),

    checkName: _.debounce(function checkName() {
      this.$store.dispatch('setTmpUserName', this.inputName).then(() => {
        this.validNameFlag =
          this.validName(this.inputName) &&
          !this.chkEmojiContains(this.inputName);
        return this.$store
          .dispatch('setTmpValidNameFlag', this.validNameFlag)
          .then(() => this.validNameFlag);
      });
    }, 1000),

    checkBirth(value) {
      this.$store.dispatch('setTmpUserBirth', value).then(() => {
        this.yearSelected = value;
        return this.yearSelected;
      });
    },

    checkSex(value) {
      this.$store.dispatch('setTmpUserSex', value).then(() => {
        this.sexSelected = value;
        return this.sexSelected;
      });
    },

    checkEducation(value) {
      this.$store.dispatch('setTmpUserEducation', value).then(() => {
        this.educationSelected = value;
        return this.educationSelected;
      });
    },

    getTagCodeList() {
      return this.$store.getters.getTagCodeList;
    },

    signUp(email, password, nickname, name, birth, sex, education) {
      const jobs = this.getTagCodeList();
      const error = this.checkValidData(
        email,
        password,
        nickname,
        name,
        birth,
        sex,
        education,
        jobs,
      );
      if (error) {
        this.titleModal = this.$i18n.t('error.title');
        this.msgModal = error;
        this.showModal = true;
      } else {
        const sexValue = sex === '1' ? SEX_TYPE.MAN : SEX_TYPE.WOMAN;
        let clientId = '';
        if (this.$route.query.clientId) {
          clientId = this.$route.query.clientId;
        }
        const loginType = clientId ? LOGIN_TYPE.CLIENT : LOGIN_TYPE.EMAIL;
        this.$store.dispatch('signUp', {
          email,
          password,
          nickname,
          name,
          birth,
          sexValue,
          education: education - 1,
          jobs,
          clientId,
          loginType,
        }).then((result) => {
          if (result.status === RESPONSE.SUCCESS.CODE) {
            this.$store.dispatch('logIn', { email, password }).then((data) => {
              // 로그인 성공 시, 임시 store 정보 clear 후, 페이지 이동.
              if (data.status === RESPONSE.SUCCESS.CODE) {
                this.$store.dispatch('clearTmpUserEmail').then();
                this.$store.dispatch('clearTmpUserPassword').then();
                this.$store.dispatch('clearTmpUserNickname').then();
                this.$store.dispatch('clearTmpUserName').then();
                this.$store.dispatch('clearTmpUserBirth').then();
                this.$store.dispatch('clearTmpUserEducation').then();
                this.$store.dispatch('clearTmpClientId').then();

                this.goPage('/acc/done');
              } else {
                this.showModal = true;
                this.titleModal = this.$i18n.t('error.title');
                this.msgModal = data.error.resultMsg;
              }
            });
          } else {
            this.titleModal = this.$i18n.t('error.title');
            this.msgModal = result.error.resultMsg;
            this.showModal = true;
          }
        });
      }
    },

    checkValidData(
      email,
      password,
      nickname,
      name,
      birth,
      sex,
      education,
      jobs,
    ) {
      if (!this.validEmail(email)) {
        this.validEmailFlag = false;
        return this.$i18n.t('error.invalid.email');
      }
      if (!this.validEmailFlag) {
        return this.$i18n.t('error.invalid.duplicateEmail');
      }
      if (!this.validPassword(password)) {
        return this.$i18n.t('error.invalid.password');
      }
      if (!this.validNicknameFlag) {
        return this.$i18n.t('error.invalid.nickname');
      }
      if (!this.validName(name)) {
        return this.$i18n.t('error.invalid.name');
      } else if (this.chkEmojiContains(name)) {
        return this.$i18n.t('error.invalid.emoji');
      }
      if (!this.validBirth(birth)) {
        return this.$i18n.t('error.invalid.birth');
      }
      if (!this.validSex(sex)) {
        return this.$i18n.t('error.invalid.sex');
      }
      if (!this.validEdu(education)) {
        return this.$i18n.t('error.invalid.education');
      }
      if (jobs.length === 0) {
        return this.$i18n.t('error.invalid.tag');
      }
      return '';
    },

    clearTmpClientId() {
      this.$store.dispatch('clearTmpClientId').then();
    },

    handleResize() {
      this.docHeight = window.innerHeight;
      this.docWidth = window.innerWidth;
    },
  },

  watch: {
    inputEmail() {
      this.checkUserId();
    },
    inputPassword() {
      this.checkPassword();
    },
    inputNickname() {
      this.checkNickname();
    },
    inputName() {
      this.checkName();
    },
  },

  mounted() {
    this.$store.dispatch('getJobs').then(() => {
      const tagList = this.$store.getters.getTagList;
      if (tagList.length > 0) {
        const tmpList = [];
        for (let ii = 0; ii < tagList.length; ii += 1) {
          tmpList.push(tagList[ii].jobName);
        }
        this.occupation = tmpList.join(', ');
      }
    });

    const clientId = this.$route.query.clientId ?
      this.$route.query.clientId :
      this.$store.getters.getTmpClientId;
    if (clientId) {
      this.$store.dispatch('getClientInfo', { clientId }).then((data) => {
        if (data.status === RESPONSE.SUCCESS.CODE) {
          if (data.data) {
            const companyName = data.data.companyName;
            const testStartDate = data.data.testStartDate;
            const testEndData = data.data.testEndDate;
            const now = new Date().getTime();
            this.headerPageTitle = companyName;
            if (now < testStartDate || now > testEndData) {
              this.titleModal = this.$i18n.t('error.title');
              this.msgModal = this.$i18n.t('error.isNotTestPeriod');
              this.showModal = true;
              this.isShow = false;
              this.clearTmpClientId();
            } else {
              this.isShow = true;
              this.$store.dispatch('setTmpClientId', clientId).then();
            }
          } else {
            this.titleModal = this.$i18n.t('error.title');
            this.msgModal = this.$i18n.t('error.invalid.clientId');
            this.showModal = true;
            this.isShow = false;
            this.clearTmpClientId();
          }
        } else {
          this.titleModal = this.$i18n.t('error.title');
          this.msgModal = data.error.resultMsg;
          this.showModal = true;
          this.isShow = false;
          this.clearTmpClientId();
        }
      });
    } else {
      this.isShow = true;
    }

    this.$store.dispatch('setTmpUserBirth', this.yearSelected).then();
    this.$store.dispatch('setTmpUserSex', this.sexSelected).then();
    this.$store.dispatch('setTmpUserEducation', this.educationSelected).then();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="scss" src="../../scss/acc-signup.scss" scoped></style>



// WEBPACK FOOTER //
// src/views/acc/acc-signup.vue